import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import ReactECharts from 'echarts-for-react'
import { CHART_THEME } from '../../../constants/project'
import { cloneDeep } from 'lodash-es'
import { sessionGetItemObj } from '../../../utils/sessionHelpers'
import { searchSummaryBudgetCost } from '../../../redux/actions/dashboard'

export default function IncomeAndExpenseChart({ requestBody }) {
  // const { showCommandButton, isEdit, onChangeIsEdit } = props

  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [chartOption, setChartOption] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [requestBody])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      const request = requestBody ? requestBody : {}
      const response = await searchSummaryBudgetCost(request)
      // console.log('resss *** ', response)
      setSchema(response)
      // setSchema(mockSchema)

      var category = []
      var approved = []
      var receive = []
      var expenses = []

      response?.datas.forEach((e) => {
        category.push(e.projectCode)
        approved.push(e.approved)
        receive.push(e.receive)
        expenses.push(e.expenses)
      })

      let charts = cloneDeep(chartSchema)

      // charts.xAxis.data = category     // แนวตั้ง
      charts.yAxis.data = category
      charts.series[0].name = response?.approved || 'ยอดอนุมัติ'
      charts.series[0].data = approved

      charts.series[1].name = response?.receive || 'ยอดรับโอน'
      charts.series[1].data = receive

      charts.series[2].name = response?.expenses || 'ยอดจ่าย'
      charts.series[2].data = expenses

      // console.log('ยอดอนุมัติ', approved)
      // console.log('ยอดรับโอน', receive)
      // console.log('ยอดจ่าย', expenses)

      setChartOption(charts)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  // console.log('ssssss', schema)

  return (
    <>
      {schema && chartOption && (
        <Panel shaded collapsible defaultExpanded header={''} bordered style={{ marginTop: 15 }}>
          <ReactECharts
            theme={CHART_THEME}
            option={chartOption}
            style={{ minHeight: '400px', width: '100%' }}
            className={'react_for_echarts'}
          />
        </Panel>
      )}
    </>
  )
}

const chartSchema = {
  title: {
    text: '',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  legend: {},
  grid: {
    left: '3%',
    right: '14%',
    bottom: '3%',
    containLabel: true,
  },
  // แนวตั้ง
  // xAxis: {
  //   type: 'category',
  //   data: [],
  // },
  // yAxis: {
  //   type: 'value',
  //   boundaryGap: [0, 0.01],
  // },
  xAxis: {
    type: 'value',
    boundaryGap: [0, 0.01],
  },
  yAxis: {
    type: 'category',
    data: [],
  },
  dataZoom: [
    {
      type: 'slider',
      show: true,
      yAxisIndex: 0,
      // yAxisIndex: [0, 1],
      // start: 1,
      // end: 100,
    },
    {
      type: 'inside',
      yAxisIndex: 0,
      // yAxisIndex: [0, 1],
      // start: 1,
      // end: 35,
    },
  ],
  series: [
    {
      name: 'ยอดอนุมัติ',
      type: 'bar',
      data: [],
      itemStyle: { normal: { color: '#41b596' } },
    },
    {
      name: 'ยอดรับโอน',
      type: 'bar',
      data: [],
      itemStyle: { normal: { color: '#53a7ed' } },
    },
    {
      name: 'ยอดจ่าย',
      type: 'bar',
      data: [],
      itemStyle: { normal: { color: '#ffc184' } },
    },
  ],
}
